import styled from 'styled-components';

export const StarsContainer = styled.span`
  display: flex;
`;
